var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lztDhPage"},[_c('div',{staticClass:"lztJpg"},[_c('img',{attrs:{"src":_vm.baseUrl+'lztDh.png',"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }